import React from 'react'
import * as Icons from 'ui/icons'
import { SquareButton } from 'ui'
import Modal from 'widgets/modals/Modal'
import OpenModalOnClick from 'support/actions/generic/OpenModalOnClick'
import UserChangesView from 'pages/app/users/partials/views/UserChangesView'
import { ExecuteOperationOnPipe, useModelKey, useValue } from '@morningtrain/react-resources'

export default function UserChangesButton () {

  const userId = useModelKey()
  const salaryPeriodId = useValue('salary_period_id')

  const modal = (
    <Modal className="max-w-6xl">
      <UserChangesView userId={userId} salaryPeriodId={salaryPeriodId}/>
    </Modal>
  )

  const closePipes = (
    <ExecuteOperationOnPipe resourceName="salary.salary_period" operationName="overview"/>
  )

  return (
    <OpenModalOnClick modal={modal} onClosePipes={closePipes}>
      <SquareButton color="btn-lightgray">
        <Icons.ExclamationCircle className="w-4 h-4"/>
      </SquareButton>
    </OpenModalOnClick>
  )
}
